<div>
  <div class="row">
    <div class="col-xs-12 col-12">
      <div>{{'DATATABLE.DISPLAYING' | translate}} {{from}} {{'DATATABLE.TO' | translate}} {{to}} {{'DATATABLE.OF' | translate}} {{totalCount}}</div>
      @if (!hideSinglePagePager || bigTotalItems > pageSize) {
        <pagination [totalItems]="bigTotalItems" [itemsPerPage]="pageSize"
          [(ngModel)]="bigCurrentPage" [maxSize]="(isMobileView$ | async) ? 3 : maxSize" class="pagination-sm" (pageChanged)="changePage($event)" [boundaryLinks]="true" [rotate]="true" (numPages)="numPages = $event"
          [firstText]="(isMobileView$ | async) ? '«' : 'First'"
          [previousText]="(isMobileView$ | async) ? '‹' : 'Previous'"
          [nextText]="(isMobileView$ | async) ? '›' : 'Next'"
        [lastText]="(isMobileView$ | async) ? '»' : 'Last'"></pagination>
      }
    </div>
  </div>
  <div class="col-xs-12" style="position: relative;">
    @if (loading) {
      <div class="table-loading-overlay">
        <div class="table-spinner"></div>
      </div>
    }

    <!-- ── Desktop table view ── -->
    @if (!(isMobileView$ | async)) {
      <div class="table-responsive" style="overflow-x: auto;">
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              @for (column of columns; track column) {
                <th class="sticky-header">
                  <div class="column title-column" (click)="sortBy(column)" ngbTooltip="{{column.description}}">
                    {{column.tag | translate}}
                    @if (column?.sortingOrder=='asc') {
                      <lucide-icon class="sort-chevron" name="chevron-up" size="12"></lucide-icon>
                    }
                    @if (column?.sortingOrder=='desc') {
                      <lucide-icon class="sort-chevron" name="chevron-down" size="12"></lucide-icon>
                    }
                  </div>
                </th>
              }
            </tr>
          </thead>
          @if (!disableHeader) {
            <tr>
              @for (column of columns; track column) {
                <th style="padding: 5px; font-size: 14px;">
                  @if (config.filtering && column.filtering) {
                    <input #filterItem id="{{column.name}}" (keyup)="filter(column, filterItem.value)" type="search" class="form-control" name="search_{{column.name}}" placeholder="search" style="min-width: 120px; font-size: 14px;" />
                  }</th>
                }
              </tr>
            }
            <tbody>
              @for (dataRow of tableData; track dataRow) {
                <tr style="font-size: 15px;">
                  @if (actionButtons) {
                    <td class="smallCell" style="padding: 5px;" >
                      @if (downloadButton) {
                        <button (click)="download(dataRow)" class="btn btn-primary">{{"DATATABLE.DOWNLOAD"| translate}}</button>
                      }
                      @if (!downloadButton) {
                        <a [routerLink]="['/'+modelView, dataRow?.id]" class="btn btn-primary">{{"DATATABLE.VIEW"| translate}}</a>
                        }&nbsp;
                        @if (auth.isloggedIn && canDelete && (userRoles===undefined || !userRoles.includes('VIEWER'))) {
                          <button type="button" class="btn btn-primary" (click)="openModal(template)">
                            {{"DATATABLE.DELETE"| translate}}
                          </button>
                        }
                        <ng-template #template>
                          <div class="modal-body text-center">
                            <p>{{'DATATABLE.DELETE_CONFIRM' | translate}} {{entityTitle}}?</p>
                            <button type="button" class="btn btn-outline-danger" (click)="confirmDeletion(dataRow?.id, entity);">{{'DATATABLE.YES' | translate}}
                            </button>
                            <button type="button" class="btn btn-primary" (click)="decline()">{{'DATATABLE.NO' | translate}}</button>
                          </div>
                        </ng-template>
                      </td>
                    }
                    @for (prop of metaInfo; track prop; let i = $index) {
                      <td  [style.background-color]="getColors(dataRow)"  style="padding: 5px;">
                        @if (columns[columns.length==metaInfo.length?i:i+1]?.button) {
                          <button
                            (click)="buttonClick(dataRow, columns[columns.length==metaInfo.length?i:i+1])"
                            class="btn btn-primary btn-sm">
                            {{(columns[columns.length==metaInfo.length?i:i+1]?.tag || 'DATATABLE.VIEW') | translate}}
                          </button>
                        }
                        @if (columns[columns.length==metaInfo.length?i:i+1]?.type === 'STATUS') {
                          @if (dataRow[prop]?.label === 'PUBLISHED') {
                            <span style="display: inline-block; background-color: var(--success-bg); padding: 6px 12px; border: 1px solid var(--success); border-radius: 4px; color: var(--success); font-weight: 500;">
                              {{dataRow[prop]?.label}}
                            </span>
                          } @else {
                            <span style="display: inline-block; padding: 6px 12px; border: 1px solid var(--fg-3); border-radius: 4px; color: var(--fg-3); font-weight: 500;">{{dataRow[prop]?.label}}</span>
                          }
                          @if (dataRow[prop]?.extra) {
                            <span style="margin-left: 6px;">{{dataRow[prop]?.extra}}</span>
                          }
                        }
                        @if (columns[columns.length==metaInfo.length?i:i+1] && !columns[columns.length==metaInfo.length?i:i+1]?.button && columns[columns.length==metaInfo.length?i:i+1]?.type!=='10' && columns[columns.length==metaInfo.length?i:i+1]?.type !== 'STATUS') {
                          <span style="display: inline-block; padding: 6px 12px;" [ngClass]="getColumnAt(i)?.colorMap ? getColumnAt(i).colorMap[dataRow[prop]] : ''">
                            @if (columns[columns.length==metaInfo.length?i:i+1]?.type=='REFERENCE' &&
                              actions.includes(dataRow[findNotificationType(columns)])) {
                              <div >
                                @if (dataRow[prop] && dataRow[prop].key) {
                                  <a [routerLink]="['/process/'+dataRow[prop].id+'/'+dataRow[prop].key]" class="btn btn-outline-primary" >
                                    {{'CONTROL-MODULE.VIEW' | translate}}
                                  </a>
                                }
                              </div>
                            } @else {
                              {{
                              (columns[columns.length==metaInfo.length?i:i+1]?.type===4 || columns[columns.length==metaInfo.length?i:i+1]?.type==='DATE')?
                              (dataRow[prop] | date: 'dd/MM/yyyy') :
                              (columns[columns.length==metaInfo.length?i:i+1]?.isNumber || columns[columns.length==metaInfo.length?i:i+1]?.type=='NUMBER' ? (dataRow[prop] | number) :
                              ( columns[columns.length==metaInfo.length?i:i+1]?.type=='NOTIFICATION' ?  ('NOTIFICATIONS.'+dataRow[prop] | translate: {task: "\""+ dataRow.referenceObject.name + "\""}) :
                              ( columns[columns.length==metaInfo.length?i:i+1]?.type=='REFERENCE' ?
                              setupLink(dataRow[findNotificationType(columns)
                              ],dataRow[prop]) :
                              (columns[columns.length==metaInfo.length?i:i+1]?.values===undefined ? dataRow[prop]:dataRow[prop]!==undefined?('FUSION_TABLE.'+dataRow[prop] | translate):"")
                              )
                              )
                              )
                              }}
                            }
                          </span>
                        }
                        @if (!columns[columns.length==metaInfo.length?i:i+1]?.button && columns[columns.length==metaInfo.length?i:i+1]?.type==='10') {
                          <button type="button" class="btn btn-link btn-sm" (click)="navigateToFile(dataRow[prop]);">{{'CSV.DOWNLOAD' | translate}}
                          </button>
                        }
                      </td>
                    }
                  </tr>
                }
                @if (data && !tableData?.length) {
                  <tr>
                    <td [attr.colspan]="columns?.length" class="text-center text-muted py-3">{{'DATATABLE.NO_DATA' | translate}}</td>
                  </tr>
                }
                @if (data?.totalSum?.length) {
                  <tr>
                    @for (column of columns; track column) {
                      <th class="sticky-header">
                        <div class="column title-column">
                          @if (data.totalSum[0][column.key]) {
                            <span>
                              Total: {{data.totalSum[0][column.key]}}
                            </span>
                          }
                        </div>
                      </th>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }

        <!-- ── Mobile filter bar (mobile only) ── -->
        @if (isMobileView$ | async) {
          <div class="mobile-filter-bar">
            <!-- Toggle button -->
            <div class="mobile-filter-toggle" (click)="mobileFiltersOpen = !mobileFiltersOpen">
              <div class="mobile-filter-toggle__left">
                <lucide-icon name="funnel" size="14"></lucide-icon>
                <span>{{ 'DATATABLE.FILTERS' | translate }}</span>
                @if (activeFilterCount > 0) {
                  <span class="mobile-filter-badge">{{ activeFilterCount }}</span>
                }
              </div>
              <div class="mobile-filter-toggle__right">
                @if (activeFilterCount > 0) {
                  <span class="mobile-filter-clear"
                    (click)="$event.stopPropagation(); clearAllFilters()">
                    {{ 'DATATABLE.CLEAR_ALL' | translate }}
                  </span>
                }
                <lucide-icon [name]="mobileFiltersOpen ? 'chevron-up' : 'chevron-down'" size="14"></lucide-icon>
              </div>
            </div>
            <!-- Collapsible filter panel -->
            @if (mobileFiltersOpen) {
              <div class="mobile-filter-panel">
                @for (column of columns; track column) {
                  @if (config.filtering && column.filtering) {
                    <div class="mobile-filter-field">
                      <label class="mobile-filter-label">{{ column.tag | translate }}</label>
                      <input
                        type="search"
                        class="form-control form-control-sm"
                        [class.mobile-filter-active]="column.filteringString"
                        [value]="column.filteringString || ''"
                        placeholder="{{ 'DATATABLE.SEARCH' | translate }}"
                        (input)="filter(column, $event.target.value)" />
                      </div>
                    }
                  }
                </div>
              }
            </div>
          }

          <!-- ── Mobile card grid view ── -->
          @if (isMobileView$ | async) {
            <div class="card-grid">
              <!-- No data message -->
              @if (data && !tableData?.length) {
                <div class="data-card-empty">
                  {{'DATATABLE.NO_DATA' | translate}}
                </div>
              }
              <!-- One card per data row -->
              @for (dataRow of tableData; track dataRow) {
                <div
                  class="data-card"
                  [style.border-left-color]="getColors(dataRow) || 'transparent'">
                  <!-- Field rows -->
                  <div class="data-card__body">
                    @for (prop of metaInfo; track prop; let i = $index) {
                      <div class="data-card__row">
                        <span class="data-card__label">{{ getColumnAt(i)?.tag | translate }}</span>
                        <span class="data-card__value">
                          <!-- Button-type column -->
                          @if (getColumnAt(i)?.button) {
                            <button
                              (click)="buttonClick(dataRow, getColumnAt(i))"
                              class="btn btn-primary btn-sm">
                              {{(getColumnAt(i)?.tag || 'DATATABLE.VIEW') | translate}}
                            </button>
                          }
                          <!-- Status (Published) column -->
                          @if (getColumnAt(i)?.type === 'STATUS') {
                            @if (dataRow[prop]?.label === 'PUBLISHED') {
                              <span style="display: inline-block; background-color: var(--success-bg); padding: 4px 10px; border: 1px solid var(--success); border-radius: 4px; color: var(--success); font-weight: 500;">
                                {{dataRow[prop]?.label}}
                              </span>
                            } @else {
                              <span style="display: inline-block; padding: 4px 10px; border: 1px solid var(--fg-3); border-radius: 4px; color: var(--fg-3); font-weight: 500;">{{dataRow[prop]?.label}}</span>
                            }
                            @if (dataRow[prop]?.extra) {
                              <span style="margin-left: 6px;">{{dataRow[prop]?.extra}}</span>
                            }
                          }
                          <!-- Text/reference/notification column -->
                          @if (!getColumnAt(i)?.button && getColumnAt(i)?.type !== '10' && getColumnAt(i)?.type !== 'STATUS') {
                            <span [ngClass]="getColumnAt(i)?.colorMap ? getColumnAt(i).colorMap[dataRow[prop]] : ''">
                              @if (getColumnAt(i)?.type=='REFERENCE' && actions.includes(dataRow[findNotificationType(columns)])) {
                                <div>
                                  @if (dataRow[prop] && dataRow[prop].key) {
                                    <a
                                      [routerLink]="['/process/'+dataRow[prop].id+'/'+dataRow[prop].key]"
                                      class="btn btn-outline-primary btn-sm">
                                      {{'CONTROL-MODULE.VIEW' | translate}}
                                    </a>
                                  }
                                </div>
                              } @else {
                                {{
                                (getColumnAt(i)?.type===4 || getColumnAt(i)?.type==='DATE') ?
                                (dataRow[prop] | date: 'dd/MM/yyyy') :
                                (getColumnAt(i)?.isNumber || getColumnAt(i)?.type=='NUMBER' ? (dataRow[prop] | number) :
                                (getColumnAt(i)?.type=='NOTIFICATION' ? ('NOTIFICATIONS.'+dataRow[prop] | translate: {task: '"'+dataRow.referenceObject?.name+'"'}) :
                                (getColumnAt(i)?.type=='REFERENCE' ? setupLink(dataRow[findNotificationType(columns)],dataRow[prop]) :
                                (getColumnAt(i)?.values===undefined ? dataRow[prop] : dataRow[prop]!==undefined?('FUSION_TABLE.'+dataRow[prop] | translate):''))))
                                }}
                              }
                            </span>
                          }
                          <!-- Download-type column (type '10') -->
                          @if (getColumnAt(i)?.type==='10') {
                            <button
                              type="button" class="btn btn-link btn-sm"
                              (click)="navigateToFile(dataRow[prop])">
                              {{'CSV.DOWNLOAD' | translate}}
                            </button>
                          }
                        </span>
                      </div>
                    }
                  </div>
                  <!-- Card action footer: View / Download / Delete -->
                  @if (actionButtons) {
                    <div class="data-card__actions">
                      @if (downloadButton) {
                        <button (click)="download(dataRow)" class="btn btn-primary btn-sm">
                          {{"DATATABLE.DOWNLOAD" | translate}}
                        </button>
                      }
                      @if (!downloadButton) {
                        <a [routerLink]="['/'+modelView, dataRow?.id]" class="btn btn-primary btn-sm">
                          <span>{{"DATATABLE.VIEW" | translate}}</span>
                        </a>
                      }
                      @if (auth.isloggedIn && canDelete && (userRoles===undefined || !userRoles.includes('VIEWER'))) {
                        <button type="button" class="btn btn-primary btn-sm"
                          (click)="openModal(cardDeleteTemplate)"
                          >
                          {{"DATATABLE.DELETE" | translate}}
                        </button>
                      }
                      <ng-template #cardDeleteTemplate>
                        <div class="modal-body text-center">
                          <p>{{'DATATABLE.DELETE_CONFIRM' | translate}} {{entityTitle}}?</p>
                          <button type="button" class="btn btn-outline-danger" (click)="confirmDeletion(dataRow?.id, entity);">{{'DATATABLE.YES' | translate}}</button>
                          <button type="button" class="btn btn-primary" (click)="decline()">{{'DATATABLE.NO' | translate}}</button>
                        </div>
                      </ng-template>
                    </div>
                  }
                </div>
              }
              <!-- Summary card (total sum row equivalent) -->
              @if (data?.totalSum?.length) {
                <div class="data-card data-card--summary">
                  <div class="data-card__body">
                    @for (prop of metaInfo; track prop; let i = $index) {
                      @if (data.totalSum[0][getColumnAt(i)?.key]) {
                        <div class="data-card__row">
                          <span class="data-card__label">{{ getColumnAt(i)?.tag | translate }}</span>
                          <span class="data-card__value">Total: {{ data.totalSum[0][getColumnAt(i)?.key] }}</span>
                        </div>
                      }
                    }
                  </div>
                </div>
              }
            </div>
          }

        </div>
      </div>
